<template>
<div class="whoSection" id="logistique">
    <div class="figures_section">
        <div class="figure_section">
            <picture class="figure_icon">
                <source :srcset="require('@/assets/whoweare/service-livraison-rapide.webp')" type='image/webp' />
                <img :src="require('@/assets/whoweare/service-livraison-rapide.png')" alt="icône camion de transport en livraison" loading="lazy" />
            </picture>
            <div class="figure_title">
                {{ $t('who.parcels') }}
            </div>
            <div class="figure_figure">
                +{{ formatNumber(200000) }}
            </div>
        </div>
         <div class="figure_section">
            <picture class="figure_icon">
                <source :srcset="require('@/assets/whoweare/stockage-marchandise-entrepot.webp')" type='image/webp' />
                <img :src="require('@/assets/whoweare/stockage-marchandise-entrepot.png')" alt="icône entrepôt logistique et stockage" loading="lazy" />
            </picture>
            <div class="figure_title">
                {{ $t('who.storage') }}
            </div>
            <div class="figure_figure">
                {{ formatNumber(20000) }} m²
            </div>
        </div>
         <div class="figure_section">
            <picture class="figure_icon">
                <source :srcset="require('@/assets/whoweare/expert-logistique-GMA.webp')" type='image/webp' />
                <img :src="require('@/assets/whoweare/expert-logistique-GMA.png')" alt="icône silhouettes des collaborateurs" loading="lazy" />
            </picture>
            <div class="figure_title">
                {{ $t('who.employees') }}
            </div>
            <div class="figure_figure">
                {{ formatNumber(100) }}
            </div>
        </div>
         <div class="figure_section">
            <picture class="figure_icon">
                <source :srcset="require('@/assets/whoweare/croissance-performance-logistique.webp')" type='image/webp' />
                <img :src="require('@/assets/whoweare/croissance-performance-logistique.png')" alt="icône tableau graphique croissance du chiffre d'affaire" loading="lazy" />
            </picture>
            <div class="figure_title">
                {{ $t('who.revenue') }}
            </div>
            <div class="figure_figure">
                {{ formatNumber(13000000) }} €
            </div>
        </div>
    </div>
    <div class="map_section">
        <div class="map_text_content">
            <h2>{{ $t('who.title') }}</h2>
            <div class="map_text">
                <p>{{ $t('map.intro') }}</p>
                <h3>{{ $t('map.title') }}</h3>
                <p>{{ $t('map.p1') }}</p>
                <p>{{ $t('map.p2') }}</p>
                <p>{{ $t('map.p3') }}</p>
                <p>{{ $t('map.p4') }}</p>
                <p>{{ $t('map.p5') }}</p>
            </div>
        </div>
        <picture class="map_img">
            <source :srcset="require('@/assets/whoweare/transport-marchandise-livraison.webp')" type='image/webp' />
            <img :src="require('@/assets/whoweare/transport-marchandise-livraison.png')" alt="carte de France affichant nos trois entrepôts à Paris, Orléans et Calais" loading="lazy" />
        </picture>
    </div>
</div>
</template>

<script>

export default {
    setup() {
        
    },
    methods: {
        formatNumber(num) {
            return num.toLocaleString('fr-FR');
        }
    }

}
</script>


<style scoped>
.whoSection {
    padding: 0 30px;
    max-width: 1440px;
    margin: auto;
    /* height: 100vh; */
}
h2 {
    text-align: left;
    color: #e91e63;
    font-size: 45px;
}
h3 {
    font-size: 20px;
    text-align: left;
    line-height: 1;
}
.figures_section {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    max-width: 1440px;
}
.figure_section {
    display: flex;
    flex-direction: column;
    text-align: left;
}
.figure_icon {
    padding: 22px;
    width: 45px;
    height: auto;
    border-radius: 50%;
    box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.1);
    align-self: center;
}
.figure_icon > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.figure_title {
    color: #212121;
    font-weight: bold;
    margin-top: 20px;
    font-size: 18px;
}
.figure_figure {
    color: #e91e63;
    font-size: 45px;
    font-weight: bold;
}
.map_section {
    display: flex;
    position: relative;
    margin-top: 70px;
    align-items: center;
}
.map_text_content {
    width: 50%;
    height: auto;
    padding: 35px 35px 35px 0;
    position: relative;
}
.map_img {
    width: 55%;
    margin-top: 0;
    position: absolute;
    right: 0;
    overflow: hidden;
}
.map_text {
    text-align: left;
}
.map_img > img {
    width: auto;
    height: auto;
    object-fit: contain;
    -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 70%, rgba(0, 0, 0, 0) 100%);
    mask-image: linear-gradient(to left, rgba(0, 0, 0, 1) 40%, rgba(0, 0, 0, 0) 100%);
}
.intro {
    padding: 50px;
    font-weight: 600;
    width: 80%;
    margin: auto;
    font-size: 20px;
}
@media screen and (min-width: 2000px ) {
    .map_text_content {
        padding: 35px 35px 35px 0;
    }
}
@media screen and (min-width: 751px ) and (max-width: 1200px){
    .figure_title {
        font-size: 13px;
    }
    .figure_figure {
        font-size: 30px;
    }
    .figures_section {
        flex-direction: row;
        flex-wrap: wrap;
    }
    .figure_section {
        width: 50%;
        text-align: center;
    }
    /* .map_section {
        flex-direction: column;
    }
    .map_text_content, .map_img {
        width: 100%;
    }
    .map_text_content {
        padding: 0;
    } */
}
@media screen and (max-width: 750px ) {
    .figures_section {
        flex-direction: column;
    }
    .figure_section {
        text-align: center;
        margin-bottom: 40px;
    }
    .map_section {
        flex-direction: column;
        margin-top: 50px;
    }
    .map_text, .map_img {
        width: 100%;
    }
    .map_img {
        position: relative;
        padding-right: 15%;
    }
    .map_img img {
        width: 100%;
        height: 100%;
    }
    h2 {
        font-size: 37px;
    }
    h3 {
        font-size: 16px;
        margin: 0 0 30px;
    }
    .map_text_content {
        padding: 0;
        width: 100%;
    }
}
</style>